import { Row, type RowProps } from '@christiankaindl/lyts'
import { type ReactNode, type CSSProperties } from 'react'
import * as styles from './Pill.css'

interface Props extends RowProps {
  gap?: number
  children?: ReactNode
  style?: CSSProperties
  /** `tight` for pills whose content already has round ends. */
  padding?: keyof typeof styles.padding
}
export default function Pill({
  children,
  gap = 0.5,
  padding = 'default',
  ...props
}: Props) {
  return (
    <Row
      asChild
      gap={gap}
      {...props}
      className={`${styles.root} ${styles.padding[padding]}${props.className ? ` ${props.className}` : ''}`}
    >
      <span>{children}</span>
    </Row>
  )
}
